import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;

export default function useCharity() {
  const [charity, setCharity] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api
      .get("/charity")
      .then((r) => {
        cached = r.data;
        setCharity(r.data);
      })
      .catch(() => {});
  }, []);
  return charity;
}
